export default "__VITE_ASSET__6b6ea124__"